import axios from "axios";
import { API_BASE_URL } from "../../config/apiConfig";

// Create axios instance with auth
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add auth token to requests
apiClient.interceptors.request.use((config) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user?.token) {
    config.headers.Authorization = `Bearer ${user.token}`;
  }
  return config;
});

export const topicsApi = {
  /**
   * GET TRENDING TOPICS
   * Endpoint: GET /api/topics/trending
   * Params: { limit }
   */
  getTrendingTopics: async (limit = 10) => {
    return apiClient.get("/topics/trending", { params: { limit } });
  },

  /**
   * GET TOPIC FEED
   * Endpoint: GET /api/topics/:topic/posts
   * Params: { limit, offset, sortBy }
   */
  getTopicFeed: async (
    topic,
    { limit = 20, offset = 0, sortBy = "recent" } = {}
  ) => {
    return apiClient.get(`/topics/${topic}/posts`, {
      params: { limit, offset, sortBy },
    });
  },

  /**
   * FOLLOW TOPIC
   * Endpoint: POST /api/topics/:topic/follow
   */
  followTopic: async (topic) => {
    return apiClient.post(`/topics/${topic}/follow`);
  },

  /**
   * UNFOLLOW TOPIC
   * Endpoint: DELETE /api/topics/:topic/follow
   */
  unfollowTopic: async (topic) => {
    return apiClient.delete(`/topics/${topic}/follow`);
  },

  /**
   * GET USER'S FOLLOWED TOPICS
   * Endpoint: GET /api/topics/following
   */
  getFollowedTopics: async () => {
    return apiClient.get("/topics/following");
  },

  /**
   * SEARCH TOPICS (Autocomplete)
   * Endpoint: GET /api/topics/search
   * Params: { q, limit }
   */
  searchTopics: async (query, limit = 10) => {
    return apiClient.get("/topics/search", {
      params: { q: query, limit },
    });
  },

  /**
   * GET TOPIC STATS
   * Endpoint: GET /api/topics/:topic/stats
   */
  getTopicStats: async (topic) => {
    return apiClient.get(`/topics/${topic}/stats`);
  },

  /**
   * GET RELATED TOPICS
   * Endpoint: GET /api/topics/:topic/related
   */
  getRelatedTopics: async (topic, limit = 5) => {
    return apiClient.get(`/topics/${topic}/related`, {
      params: { limit },
    });
  },
};

export default topicsApi;
